import React from 'react';
import './ServerDownBanner.css';

const ServerDownBanner = ({ isVisible = false }) => {
  if (!isVisible) return null;

  return (
    <div className="server-down-banner">
      <div className="banner-content">
        <span className="banner-icon">⚠️</span>
        <span className="banner-text">
          The website is currently experiencing technical issues with the sign
          in process. We are working to resolve the issue and appreciate your
          patience.
        </span>
      </div>
    </div>
  );
};

export default ServerDownBanner; 